import axios from 'axios';
import { config } from './config';
import apiClient from "./apiClient";

// const apiClient = axios.create({
//   baseURL: config.API_URL,
//   headers: { "Content-Type": "application/json" },
// });

export const profileService = {
  getMetrics: async (token: string) => {
    const response = await apiClient.get('/profile/metrics', {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  },
};
